import { AxiosResponse, AxiosRequestConfig } from 'axios'
import Qs from 'qs'

/* Axios 基本配置  */
const config: AxiosRequestConfig = {
  /* SSO必须Header */
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },

  /* 基础API */
  baseURL: '/',

  /* 处理返回值  */
  transformResponse: [
    (data: AxiosResponse) => {
      return data
    }
  ],

  /* 序列化返回值  */
  paramsSerializer: (params: any) => {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },

  /* 超时设置  */
  timeout: 30000,

  /* 最大返回值 */
  maxContentLength: 2000,

  /* 跨域共享cookie  */
  withCredentials: false,

  /* 返回类型  */
  responseType: 'json',

  /* 上传时处理 */
  onUploadProgress: (progressEvent: any) => {
    Math.round((progressEvent.loaded * 100) / progressEvent.total)
  },

  /* 下载时处理 */
  onDownloadProgress: (progressEvent: any) => {
    Math.round((progressEvent.loaded * 100) / progressEvent.total)
  }
}

export default config
